import getPublicUrl from "@/libs/get-public-url";
import { useCachedImage } from "@/libs/hooks/cached-image";
import { useCreatorStreamingStatus } from "@/libs/hooks/use-creator-streaming-status";
import { creatorStore } from "@/libs/stores/creator.store";
import { Avatar, AvatarBadge, Box } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";

const MobXCreatorAvatar = observer(({ id, size = "lg", ...rest }) => {
  const creator = creatorStore.getCreator(id);
  //official account creator id
  const defaultCreator = creatorStore.getCreator('01JYZF8GY8QZG2VYWC90P0EF7V')
  const navigate = useNavigate();
  const imageUrl = creator?.picture ? getPublicUrl(creator.picture) : getPublicUrl(defaultCreator.picture);
  const cachedImageUrl = useCachedImage(imageUrl);
  const picture = cachedImageUrl || imageUrl;
  const isStreaming = useCreatorStreamingStatus(id);

  const goToCreator = () => {
    if (creator?.slug) {
      console.log("goToCreator", creator.slug);
      if (isStreaming) {
        navigate(`/s/@${creator.slug}`);
      } else {
        navigate(`/c/@${creator.slug}`);
      }
    }
  };

  if (!creator) {
    return <div></div>;
  }

  return (
    <Box position="relative" display="inline-block">
      <Avatar
        role="button"
        src={picture }
        size={size}
        {...rest}
        onClick={goToCreator}
        border={isStreaming ? "3px solid red" : "none"}
      >
        {!isStreaming && creator.isOnline && (
          <AvatarBadge
            position="absolute"
            boxSize=".6em"
            borderWidth=".1em"
            borderColor="primary.100"
            bg="green.500"
            bottom=".3em"
            right=".1em"
          />
        )}
      </Avatar>
      {isStreaming && (
        <Box
          position="absolute"
          bottom="0px"
          left="50%"
          transform="translateX(-50%)"
          bg="red.500"
          color="white"
          px={2}
          py={0.5}
          borderRadius="md"
          fontSize="2xs"
          fontWeight="bold"
          whiteSpace="nowrap"
          zIndex={10}
        >
          直播中
        </Box>
      )}
    </Box>
  );
});

export default MobXCreatorAvatar;
